module.exports = __webpack_public_path__ + "img/success.b96e0ddf.png";